module.exports = __webpack_public_path__ + "static/img/69-1.53d67f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/69-1.jpg
// module id = HcRO
// module chunks = 0